/**
 * Path to fetch singletons (i.e Objects with properties)
 * @constant
 */
const singleton = 'api/content/item/'
/**
 * Path to fetch collections (i.e. list of objects)
 * @constant
 */
const collection = 'api/content/items/'

/**
 * Represents the default state for CMS-managed UI content.
 * 
 * Used in `cmsStore.js` to set initial state of store before any actions/getters are executed`.
 *
 * Structure:
 * - **singleton**: Static CMS resources (e.g., navbar, footer) — one item per endpoint.
 * - **collection**: Repeatable CMS resources (e.g., articles, disclaimers).
 * 
 * Each CMS item shares a common structure:
 * @typedef {Object} CmsItem
 * @property {string} endpoint - URL path for the CMS API endpoint.
 * @property {Object|null} value - Fetched payload; null until fetched.
 * @property {boolean} isLoading - `true` while fetch is in progress.
 * @property {string|null} error - Error message from last fetch attempt.
 *
 * @constant
 * @type {{ singleton: Record<string, CmsItem>, collection: Record<string, CmsItem> }}
 */

export const cmsContent = {
  singleton: {
    downloadOptions: {
      endpoint: singleton + 'downloadOptions',
      value: null,
      isLoading: false,
      error: null
    },
    dokumentMetaData: {
      endpoint: singleton + 'dokumentMetadata',
      value: null,
      isLoading: false,
      error: null
    },
    panes: {
      endpoint: singleton + 'panes',
      value: null,
      isLoading: false,
      error: null
    },
    previewBox: {
      endpoint: singleton + 'previewBox',
      value: null,
      isLoading: false,
      error: null
    },
    footer: {
      endpoint: singleton + 'footer',
      value: null,
      isLoading: false,
      error: null
    },
    sortType: {
      endpoint: singleton + 'sortType',
      value: null,
      isLoading: false,
      error: null
    },
    controlsTop: {
      endpoint: singleton + 'controlsTop',
      value: null,
      isLoading: false,
      error: null
    },
    hero: {
      endpoint: singleton + 'hero',
      value: null,
      isLoading: false,
      error: null
    },
    knownIssues: {
      endpoint: singleton + 'errors',
      value: null,
      isLoading: false,
      error: null
    },
    aboutMenu: {
      endpoint: singleton + 'aboutMenu',
      value: null,
      isLoading: false,
      error: null
    },
    filterMenu: {
      endpoint: singleton + 'filterMenu',
      value: null,
      isLoading: false,
      error: null
    },
    mapSearch: {
      endpoint: singleton + 'mapsearch',
      value: null,
      isLoading: false,
      error: null
    },
    navbar: {
      endpoint: singleton + 'navbar',
      value: null,
      isLoading: false,
      error: null
    },
    brand: {
      endpoint: singleton + 'brand',
      value: null,
      isLoading: false,
      error: null
    },
    metadata: {
      endpoint: singleton + 'metadata',
      value: null,
      isLoading: false,
      error: null
    },
    feedback: {
      endpoint: singleton + 'feedback',
      value: null,
      isLoading: false,
      error: null
    },
    newsHeader: {
      endpoint: singleton + 'news',
      value: null,
      isLoading: false,
      error: null
    },
    langList: {
      endpoint: singleton + 'LanguageList',
      value: null,
      isLoading: false,
      error: null
    }
  },
  collection: {
    infoboks: {
      endpoint: collection + 'infoboks',
      value: null,
      isLoading: false,
      error: null
    },
    disclaimer: {
      endpoint: collection + 'disclaimer',
      value: null,
      isLoading: false,
      error: null
    },
    dokumenter: {
      endpoint: collection + 'dokumenter',
      value: null,
      isLoading: false,
      error: null
    },
    news: {
      endpoint: collection + 'news',
      value: null,
      isLoading: false,
      error: null
    },
    about: {
      endpoint: collection + 'about',
      value: null,
      isLoading: false,
      error: null
    }
  }
}
